import i18next from "i18next";
import styles from "../styles.css";

export const getEditTemplate = () => `
    <style>
        ${styles}
    </style>
    <div class="modal-week-container">
        <div class="input-container" slot="children">
 
            <div class="form-row">
                <div class="form-block">
                    <p class="form-label">${i18next.t($ => $.scheduleBacnet.dayOfWeek)}</p> 
                    <fw-radio-group id="week-day-edit" name="week-day-edit" orientation="row" >
                        <fw-radio value="0">${i18next.t($ => $.scheduleBacnet.mo)}</fw-radio>
                        <fw-radio value="1">${i18next.t($ => $.scheduleBacnet.tu)}</fw-radio>
                        <fw-radio value="2">${i18next.t($ => $.scheduleBacnet.we)}</fw-radio>
                        <fw-radio value="3">${i18next.t($ => $.scheduleBacnet.th)}</fw-radio>
                        <fw-radio value="4">${i18next.t($ => $.scheduleBacnet.fr)}</fw-radio>
                        <fw-radio value="5">${i18next.t($ => $.scheduleBacnet.sa)}</fw-radio>
                        <fw-radio value="6">${i18next.t($ => $.scheduleBacnet.su)}</fw-radio>
                    </fw-radio-group>  
                </div>          
            </div>

            <div class="form-row form-title justify-between">
                <p>${i18next.t($ => $.scheduleBacnet.event)}</p>
                <fw-button id="add-event" color="secondary">${i18next.t($ => $.scheduleBacnet.add)}</fw-button>
            </div>

            <div class="grid-container">
                <div class="grid-header">
                    <div>${i18next.t($ => $.scheduleBacnet.time)}</div>
                    <div>${i18next.t($ => $.scheduleBacnet.dataType)}</div>
                    <div>${i18next.t($ => $.scheduleBacnet.value)}</div>
                    <div></div> <!-- Пустой элемент для крестика удаления -->
                </div>
                <div class="grid-body" id="events">
                    
                </div>
            </div>  
        </div>
        
        <div class="modal-buttons-wrap">
            <fw-tooltip id="tooltip" placement="bottom" trigger="hover" content="">
                <fw-button id="submit" color="primary">${i18next.t($ => $.apply)}</fw-button>
            </fw-tooltip>
            <fw-tooltip id="tooltip" placement="bottom" trigger="hover" content="">
                <fw-button id="delete" color="primary">${i18next.t($ => $.delete)}</fw-button>
            </fw-tooltip>
            <fw-button id="reset" color="secondary">${i18next.t($ => $.cancel)}</fw-button>
        </div>
    </div>
`;
